export const exchangeRateEndpoints = {
  default: '/exchange-rates' as const,
  list: (groupId: string) => `/companies/${groupId}/group/exchange-rates` as const,
  detail: (groupId: string, seriesId: number) => `/companies/${groupId}/group/exchange-rates/${seriesId}` as const
}

export default exchangeRateEndpoints
